import React from 'react';
import API from '@aws-amplify/api';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import BiColorHeader from '../../biColorHeader';
import ApplicationHeader from './components/applicationHeader';
import ApplicationList from './components/applicationList';
import useRequestBuilder from './useRequestBuilder';
import useDebounce from '../../../utils/useDebounce/useDebounce';
import { expandScholarshipApplications } from '../../../utils/expandScholarshipApplications';
import ListFilters from '../../listFilters/ListFilters';
import { ShipyardContext } from '../../Context';

const ScholarshipApplication = () => {
    const { userSettings, listSettings, setListSettings } = React.useContext(ShipyardContext);

    const isSchoolAdmin = userSettings.UserType === 2;
    const isScholarshipAdmin = userSettings.UserType === 3;

    const [t] = useTranslation();
    const prefixedTableHeaders = {
        UniqueID: t('Applications.ScholarshipOrg.Grid.UniqueID'),
        StudentLastName: t('Applications.ScholarshipOrg.Grid.StudentLastName'),
        StudentFirstName: t('Applications.ScholarshipOrg.Grid.StudentFirstName'),
        TermDescription: t('Applications.ScholarshipOrg.Grid.Term'),
        DOB: t('Applications.ScholarshipOrg.Grid.DateOfBirth'),
        SchoolName: t('Applications.ScholarshipOrg.Grid.School'),
        ApplicationTypeID: t('Applications.ScholarshipOrg.Grid.Type'),
        Username: t('Applications.ScholarshipOrg.Grid.Username'),
        StatusId: t('Applications.ScholarshipOrg.Grid.Status'),
    };

    const callApi = async (params) => {
        try {
            let res = await API.post('ShipyardAPI', '/applications/scholarship', {
                body: {
                    pFilterString: params.filterString,
                    pSort: params.sortString,
                    pRecOffset: params.recOffset,
                },
            });

            return {
                headers: Object.entries(prefixedTableHeaders).map(([key, value]) => {
                    return {
                        label: value,
                        id: key,
                        handleSort: requestBuilder.handleSort,
                        key: key,
                    };
                }),
                data: expandScholarshipApplications(res),
            };
        } catch (e) {
            console.log('catch error', e);
        }
    };

    const debouncedGet = useDebounce(() => requestBuilder.getInvoices(callApi));
    const debouncedLoadMore = useDebounce(() => {
        return requestBuilder.loadMore(callApi);
    }, 200);

    const requestBuilder = useRequestBuilder('StudentLastName', 'application');

    React.useEffect(() => {
        if (listSettings.target !== 'application') {
            setListSettings({
                ...listSettings,
                useCache: false,
            });
        }
        requestBuilder.getFilters('/applications/filters');
    }, []);

    React.useEffect(() => {
        debouncedGet();
    }, [requestBuilder.sortString, requestBuilder.filterString, requestBuilder.term]);

    return (
        <Box sx={{ padding: '16px' }}>
            <ApplicationHeader
                headerTitle={
                    <BiColorHeader
                        left="My "
                        right="Applications."
                    />
                }
            />
            <ListFilters {...requestBuilder} />
            <ApplicationList
                {...requestBuilder}
                reload={debouncedGet}
                loadMore={debouncedLoadMore}
                list={requestBuilder.listData}
                preparedColumns={requestBuilder.tableHeaders}
                isScholarshipAdmin={isScholarshipAdmin}
                isSchoolAdmin={isSchoolAdmin}
            />
        </Box>
    );
};

export default ScholarshipApplication;
